import { finish, error } from '../../../modules/customers/actions/update';

import api from '../../../api';

export function request(dispatch, { id, data }) {
    api.patch('/customers/' + id, data).then(
        (customer) => dispatch(finish(customer)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
